// export const API_URL = 'http://192.168.40.124:5000'
// export const API_URL = 'http://localhost:5000'
export const API_URL = 'https://placezioestate-backend.onrender.com'




// export const API_URL = 'https://backend.placezioestate.com'


export  const brandColor = '#54BD95'


export const phoneNumber = '8318150076';
